import { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import toastr from "../elements/toast";
import { useDispatch, useSelector } from "react-redux";
import {
  getLanguageCookie,
  getStorageValue,
  getZipCode,
  Regex,
  zipObjectCovert,
} from "../../service/shared.service";
import httpApiCall from "../../service/api.service";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import Autocomplete, { usePlacesWidget } from "react-google-autocomplete";
import Nav from "react-bootstrap/Nav";
import { copy, referral, eyeIconHide, eyeIconShow, backblack, dataLoading } from "../../assets/assets";
import "./new-business.scss";
import { Dropdown, Spinner } from "react-bootstrap";
import { saveAgentBusinessCount } from "../../Redux/Slices/MainSlice";
import InputMask from 'react-input-mask';
import Table from "../elements/tableComponent";
import { formatDate, formatDate2 } from "../../utils/DateFormat";
import NoDataFound from "../NoDataFound/NoDataFound";
import ConfirmationModal from "../elements/confirmationModal";
import SendReminderModal from "../elements/sendReminderModal";
import ReminderModal from "../elements/reminderDetails";
import {handleInput} from "../../service/common_function";


const NewBusinessComponent = () => {
  const navType = {
    NEWBUSINESS: "NEWBUSINESS",
    DIRECTINVITE: "DIRECTINVITE",
    LOGS: 'LOGS'
  };
  const copyClassType = {
    COPYREFERRALCODE: "COPYREFERRALCODE",
    COPYREFERRALLINK: "COPYREFERRALLINK",
  };
  const navigate = useNavigate();
  const [partnerProfile, setPartnerProfile]: any = useState({});
  const [phoneRegex, setPhoneRegex] = useState<{
  phoneRegexLength: string;
  phone_length: string | number;
  min_phone_length: string | number;
}>({
  phoneRegexLength: "",
  phone_length: "",
  min_phone_length:""
});
  const [mobileCode, setMobileCode] = useState();
  const [doctor_email, setDoctorEmail] = useState("");
  const [doctor_phone, setDoctorPhone] = useState("");
  const [tabType, setTabType] = useState(navType.NEWBUSINESS);
  const [codeCopiedType, setCodeCopiedType] = useState("");
  const [country_code, setCountryCode]: any = useState([]);
  let partnerData: any = getStorageValue("partnerData");
  const [allIndustries, setIndustries] = useState([]);
  const [subIndustries, setSubIndustry] = useState([]);
  const [selectedZipCode, setZipCode]: any = useState({});
  const [isModalOpen, setModalOpen] = useState(false);
  const [isDetailModalOpen, setDetailModalOpen] = useState(false);
  const [detailData, setDetailData] = useState(null);
  const [isReminderModalOpen, setReminderModalOpen] = useState(false);
  const [itemToResend, setItemToResend] = useState(null);
  const [itemToDelete, setItemToDelete] = useState({ id: '' });
  const [emailError, setEmailError] = useState({
    link: '',
    error: ''
  });
  const [selectFieldIds, setSelectFieldIds] = useState({
    industry_id: "",
    sub_industry_id: "",
    language_preferred: '',
  });
  let answer = useSelector((state: any) => state.APIData.getSetting);
  // const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  const [directInvite, setDirectInvite] = useState({
    doctor_first_name: "",
    doctor_email: "",
    doctor_mobile: "",
    doctor_mobile_country_code: "",
    language_preffered: "en",
    notes: ''
  });


  const directInviteValidation = Yup.object({
    doctor_first_name: Yup.string().required("Please enter name").matches(Regex.name, 'Invalid name'),
    doctor_email: Yup.string().email("Invalid email format").matches(Regex.email, "Please enter a valid email"),
    doctor_mobile: Yup.string(),
    // language_preffered: Yup.string().required("Please select language"),
    notes: Yup.string().required("Please enter note"),

  });

  const handleInviteSubmit = async (formData: any, { resetForm }: any) => {
    toastrService.dismiss();
    if ((formData.doctor_first_name).length > 100) {
      toastrService.showError('Please enter valid name');
      return;
    }
    if ((!formData.doctor_email.trim().length) && (formData.doctor_mobile.trim().length < 6)) {
      toastrService.showError('Please enter valid phone number or email');
      return;
    }
    const profileData = getStorageValue("partnerProfile");
    const body: any = {
      access_token: getStorageValue("partnerToken"),
      invite_email: formData.doctor_email || null,
      // invite_name: formData.doctor_first_name,
      invite_mobile: formData.doctor_mobile,
      invite_mobile_country_code: formData.doctor_mobile ? mobileCode : '',
      language_preffered: "en",
      notes: formData.notes,
      is_resend_reminder: 0,
      referral_code: profileData && profileData.length ? profileData[0]["referral_code"] : "",
      referral_name: formData.doctor_first_name,
      is_agent: 0,
      referral_parent_id: null
    };

    setSppiner(true);
    let resp = await httpApiCall({ api: "send_invite", type: "post", body });
    setSppiner(false);
    if (resp && !resp.is_error) {
      resetForm();
      setDirectInvite({
        doctor_first_name: "",
        doctor_email: "",
        doctor_mobile: "",
        doctor_mobile_country_code: "",
        language_preffered: "en",
        notes: ''
      });
      toastrService.showSuccess("Invite has been sent successfully");
      setLogData([]);
      setTabType(navType.LOGS);
      getReferrals();
    } else {
      if (resp && resp.link) {
        const error = resp.original_text || resp.err;
        setEmailError((businessError) => ({
          ...businessError,
          link: resp && resp.link,
          error: error
        }));
      } else {
        toastrService.showError(resp.original_text || resp.err);
      }
    }
  };





  const [data, setData] = useState({
    doctor_first_name: "",
    doctor_last_name: "",
    doctor_email: "",
    doctor_mobile: "",
    doctor_mobile_country_code: "",
    ind_id: "",
    sub_ind_id: "",
    practice_address: "",
    sub_industry: "",
    language_preferred: "",
    zip: "",
    state_id: "",
    city_id: "",
    state: "",
    city: "",
    city_name: '',
    state_name: ''
  });

  const validationSchema = Yup.object({
    doctor_first_name: Yup.string().required("Please enter first name").matches(Regex.name, 'Invalid first name'),
    doctor_last_name: Yup.string().required("Please enter last name").matches(Regex.name, 'Invalid last name'),
    doctor_email: Yup.string()
      .email("Invalid email format")
      .required("Please enter email Required").matches(Regex.email, "Please enter a valid email"),
    doctor_mobile: Yup.string().required("Please enter phone number").min(+phoneRegex.min_phone_length,`Phone number should be at least ${phoneRegex.min_phone_length} digits`).max(+phoneRegex.phone_length, `Phone number is not valid`),
    practice_address: Yup.string().required("Please provide your address"),
    ind_id: Yup.string()
      .required("Please select industry"),
    // language_preferred: Yup.string()
    //   .required("Please select preferred communication langauge"),
    zip: Yup.string().required("Please enter Zip code"),
    sub_industry: Yup.string().when([], (i, schema) => {
      return subIndustries?.length > 0 &&
        selectFieldIds.sub_industry_id == "9999"
        ? schema.required("Sub industry is required")
        : schema.notRequired();
    }),

    // sub_ind_id: Yup.string()
    // .required("Please select sub industry")
  });
  const [sppiner, setSppiner] = useState(false);
  useEffect(() => {
    // console.log(partnerData);
    const body = {
      access_token: getStorageValue("partnerToken"),
    };
    httpApiCall({ api: "get_industry_list", type: "post", body, }).then((data) => {
      if (data && !data.is_error) {
        setIndustries(data.industries);
      }
    });
    setPartnerProfile(partnerData);
    // if (location.state && location.state.length) {
    //    setIndustries(location.state);
    // }
    if (partnerData && partnerData.country_currency_info && partnerData.country_currency_info.country) {
      setMobileCode(partnerData.country_currency_info.country.mobile_code);
    }
    if (partnerData && partnerData.country_currency_info && partnerData.country_currency_info.country) {
      partnerData["country_code"] =
        partnerData.country_currency_info.country["country_code"];
      let countries = [];
      countries.push(partnerData["country_code"]);
      const US_UT_country_codes = ['VI', 'PR', 'GU', 'AS', 'MP'];
      if (partnerData["country_code"] == 'US') {
        countries = [...countries, ...US_UT_country_codes];
      }

      setCountryCode(countries);
    }
    if (!answer || (answer && !answer.country_data)) {
      answer = getStorageValue('settingsData');
    }
    if (partnerData && partnerData.country_currency_info && partnerData.country_currency_info.country) {
      const countryData = answer && answer.country_data && answer.country_data.filter((item: any) => item['country_id'] == partnerData.country_currency_info.country['country_id']);
      if (countryData && countryData.length) {
        updateMasking(countryData[0]['country_phone_format']);
        setPhoneRegex((data) => ({
          ...data,
          min_phone_length: countryData[0]['min_phone_length'] || 7,
          phone_length: countryData[0]['phone_length'] || 12,
        }));
      }
    }
  }, []);
  const toastrService = new toastr(true);
  const dispatch = useDispatch();
  const [hidezipCode, setHidezipCode] = useState(false);
  const countData = useSelector(
    (state: any) => state?.APIData?.agentBusinessCount
  );
  const language = useSelector((state: any) => state?.APIData?.getSetting?.language_data)
  const [logData, setLogData] = useState<any>();
  const [shimmer, setShimmer] = useState(false);
  const columns = [
    { title: "S.No.", dataKey: "sno" },
    { title: "Referral Details", dataKey: "referral_email" },
    { title: "Referral Date", dataKey: "date_added" },
    { title: "Last Reminder", dataKey: "last_date_added" },
    { title: "Status", dataKey: "status" },
    { title: "", dataKey: "action" },
    { title: "", dataKey: "reminder" },
    { title: "", dataKey: "detail" },
  ];
  const rows =
    logData &&
    logData.map((row: any, index: number) => [
      index + 1,
      <>
      <span><strong> {row.referral_name}</strong></span><br />
      {row?.referral_email && (
        <>
          <span>{row.referral_email}</span><br />
        </>
      )}
      {row?.referral_mobile && (
          <span>{row.referral_mobile}</span>
      )}
    </>,
      formatDate2(row.date_added),
      JSON.parse(row?.reminder_obj).length ? formatDate2(JSON.parse(row?.reminder_obj)[JSON.parse(row?.reminder_obj).length - 1]?.date_added) : 'N.A',
      row.status == 0 ? 'Not Registered' : 'Registered'
    ]);
  const [selectedChoice, setSelectedChoice] = useState({
    label: "All",
    value: 0,
  });
  const choices = [
    {
      value: 0,
      label: "All",
    },
    {
      value: 1,
      label: "Registered",
    },
    {
      value: 2,
      label: "Not Registered",
    },
  ];
  const langList = [{ value: 'en', label: "English" }, { value: 'de', label: "Deutsch" }, { value: 'es', label: "Español" }, { value: 'fr', label: "Französisch" },
  { value: 'it', label: "Italiano" }, { value: 'ja', label: "日本語" }, { value: 'pl', label: "Polski" }, { value: 'ru', label: "Русский" }]



  const handleSendReminder = (item: any) => {
    const getIdData = logData[item[0] - 1];
    const reminderObj = getIdData?.reminder_obj ? JSON.parse(getIdData.reminder_obj) : [];

    let referralMobile =
      !getIdData.referral_mobile && reminderObj.length
        ? reminderObj[reminderObj.length - 1]?.referral_mobile || ''
        : getIdData.referral_mobile || '';

    setItemToResend({
      ...getIdData,
      referral_mobile: referralMobile,
    });

    setReminderModalOpen(true);
  };
 

  const handleDelete = (item: any) => {
    const getIdData = logData[item[0] - 1];
    setItemToDelete(getIdData);
    setModalOpen(true);
  };


  const showDetail = (detail: any) => {
    const getIdData = logData[detail[0] - 1];
    setDetailData(getIdData);
    setDetailModalOpen(true)
  }

  const handleConfirmDelete = async () => {

    const body: any = {
      access_token: getStorageValue("partnerToken"),
      refer_id: itemToDelete ? itemToDelete?.id : ''
    }

    setSppiner(true);
    setItemToDelete({ id: '' });
    setModalOpen(false);
    let resp = await httpApiCall({ api: "delete_doctor_referral", type: "post", body });
    setSppiner(false);
    if (resp && !resp.is_error) {
      toastrService.showSuccess('Invite log deleted successfully')
      getReferrals();
    } else {
      toastrService.showError('Failed to delete invite log')

    }
  }

  const placeSelectedZip = async (place: any, setFieldValue: any) => {
    setSppiner(true);
    setHidezipCode(true);
    const placeData = await getZipCode(zipObjectCovert(place));
    if (placeData) {
      setSppiner(false);
      setZipCode(placeData);
      data.city = placeData.city;
      data.state = placeData.state_name;
      data.zip = placeData.zip;
      setData((businessData) => ({
        ...businessData,
        state_name: placeData.state_name,
        city_name: placeData.city,
        city_id: placeData.city_id,
        zip: placeData.zip,
      }));
      setFieldValue("state_name", placeData.state_name);
      setFieldValue("city_name", placeData.city);
      setFieldValue("zip", placeData.zip);
    }
    setHidezipCode(false);
  };

  const handleSubmit = async (formData: any) => {
    if (selectFieldIds.sub_industry_id == "9999" && (!formData.sub_industry || (formData.sub_industry && !(formData.sub_industry.trim())))) {
      toastrService.showError('Please enter valid sub industry');
      return;
    }
    if (!data.city_id) {
      toastrService.showError('Please enter valid zip code');
      return;
    }
    if ((formData.first_name + " " + formData.last_name).length > 100) {
      toastrService.showError('Please enter valid name');
      return;
    }
    const lang = await getLanguageCookie();
    const profileData = getStorageValue("partnerProfile");
    const body: any = {
      access_token: getStorageValue("partnerToken"),
      doctor_email: formData.doctor_email,
      // title: formData.doctor_title,
      doctor_first_name: formData.doctor_first_name,
      doctor_last_name: formData.doctor_last_name,
      doctor_mobile: formData.doctor_mobile,
      doctor_mobile_country_code: mobileCode,
      country_id:
        partnerData.country_currency_info &&
        partnerData.country_currency_info.country["country_id"], currency_id:
        partnerData.country_currency_info &&
        partnerData.country_currency_info.currency &&
        partnerData.country_currency_info.currency[0]["currency_id"],
      doctor_speciality: 0,
      referral_code:
        profileData && profileData.length
          ? profileData[0]["referral_code"]
          : "",
      practice_address: formData.practice_address,
      city_id: data.city_id,
      ind_id: selectFieldIds.industry_id,
      // ind_name: formData.ind_name,
      // sub_ind_name: formData.sub_ind_name,
      sub_ind_id:
        selectFieldIds.sub_industry_id == "9999"
          ? 9999
          : selectFieldIds.sub_industry_id,
      sub_ind_name:
        selectFieldIds.sub_industry_id == "9999" ? formData.sub_industry : "",
      language_preffered: 'en' // selectFieldIds.language_preferred || lang,
      // pu_id: pu_id ? pu_id : undefined
    };
    if (selectFieldIds.industry_id == "9999") {
      body['ind_name'] = 'Others'
    }
    setSppiner(true);
    httpApiCall({ api: "add_doctor", type: "post", body })
      .then((resp) => {
        setSppiner(false);
        if (resp && !resp.is_error) {
          dispatch(
            saveAgentBusinessCount({
              total_agents: countData.total_agents,
              total_business: Number(countData.total_business) + 1,
            })
          );
          toastrService.showSuccess("Business added sucessfully");
          navigate("/app/business");
        } else {
          if (resp && resp.link) {
            const error = resp.original_text || resp.err;
            setEmailError((businessError) => ({
              ...businessError,
              link: resp && resp.link,
              error: error
            }));
          } else {
            toastrService.showError(resp.original_text || resp.err);
          }
        }
      })
      .catch((error) => {
        console.log("Error in new business", error);
      });
  };


  const updateMasking = (format: "") => {
    const phoneRegexVar = format?.replace(/#/g, "9");
    // phoneRegex = phoneRegexVar;
    // setPhoneRegex(phoneRegexVar);
    setPhoneRegex((data) => ({
      ...data,
      phoneRegexLength: phoneRegexVar
    }));
  }

  const subIndustryChange = async (index: any) => {
    selectFieldIds.sub_industry_id = index;
    setSelectFieldIds((subFields: any) => ({
      ...subFields,
      sub_industry_id: index,
    }));
  };

  const industryChange = async (selectedIndex: any) => {
    // console.log(selectedIndex);
    const body = {
      access_token: getStorageValue("partnerToken"),
      ind_id: selectedIndex
    };
    const subIndusItem = await httpApiCall({
      api: "doctor_speciality_list",
      type: "post",
      body,
    });
    if (subIndusItem && subIndusItem.doctor_speciality) {
      setSubIndustry(subIndusItem.doctor_speciality);
      setSelectFieldIds((subFields: any) => ({
        ...subFields,
        industry_id: selectedIndex,
        sub_industry_id: subIndusItem.doctor_speciality[0]["doctor_speciality"],
      }));
    }
  };

  const copyToClipboard = async (code: any, type: any) => {
    setCodeCopiedType(type);
    navigator.clipboard.writeText(code);
    setTimeout(() => {
      setCodeCopiedType("");
    }, 3000);
  };
  // const goBack = () => {
  //   const id = searchParams.get("id")
  //   if (id) {
  //     navigate("/app/dashboard")
  //     // searchParams.delete("id")
  //     // setSearchParams(searchParams)
  //   } else {
  //     navigate("/app/business")
  //   }

  // }

  const getReferrals = async (filter = 0) => {
    setShimmer(true);
    // return  
    const body = {
      access_token: getStorageValue("partnerToken"),
      limit: 10,
      offset: 0,
      filter,
      is_agent: 0
    }
    const data = await httpApiCall({ api: "get_partner_referrals", type: "post", body });
    setShimmer(false);
    if (!data.is_error) {
      setLogData(data.referrals)
      console.log(data?.referrals.map((item: any) => JSON.parse(item?.reminder_obj)));
      
      
    } else {
      setLogData([])
    }
  }

  const onPhoneChange = (event: any, setFieldValue: any, addBusiness:boolean) => {
    if (event.target.value) {
      event.target.value = event.target.value.replace(/[^0-9]+/g, "");
    }
    if(addBusiness) {
      setData((businessData) => ({
        ...businessData,
        doctor_mobile: event.target.value
      }));
    }
    setFieldValue('doctor_mobile', event.target.value);
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-2 col-lg-3">
            <div className="nav_tabs -d-flex justify-content-center">
              {/* <div className="back d-none d-lg-block">
          <button
            className="mb-0 border-0 bg-transparent"
            onClick={goBack}
          >
            <img src={backblack} alt="" />
            Back
          </button>
        </div> */}
              <Nav.Item
                style={{ padding: "15px" }}
                className={tabType == navType.NEWBUSINESS ? "active" : ""}
                id="nav_tab_1"
                onClick={() => { setTabType(navType.NEWBUSINESS); emailError.link = ''; }}
              >
                Add Business
              </Nav.Item>
              <Nav.Item
                style={{ padding: "15px" }}
                id="nav_tab_2"
                className={tabType == navType.DIRECTINVITE ? "active" : ""}
                onClick={() => { setTabType(navType.DIRECTINVITE); emailError.link = ''; }}
              >
                Direct Invite
              </Nav.Item>
              <Nav.Item
                style={{ padding: "15px" }}
                id="nav_tab_3"
                className={tabType == navType.LOGS ? "active" : ""}
                onClick={() => (
                  setLogData([]),
                  setTabType(navType.LOGS),
                  getReferrals()
                )
                }
              >
                Invited Business Logs
              </Nav.Item>
            </div>

          </div>
          <div className="col-xl-10 col-lg-9 py-4">
            {tabType == navType.NEWBUSINESS && (
              <div className="Add_business">
                <div className="flow-right">
                  <Formik
                    onSubmit={handleSubmit}
                    initialValues={data}
                    validationSchema={validationSchema}
                  >
                    {({ setFieldValue }) => (

                      <Form autoComplete="set_auto_complete_business">
                        <div className="row">
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label htmlFor="" className="labels_input">
                                First Name
                              </label>
                              <Field
                                className="form-control"
                                id="business_first_name"
                                type="text"
                                name="doctor_first_name"
                                placeholder="Enter first name"
                                autoComplete="doctor_first_name"
                              />
                              <small className="text-danger m-2">
                                <ErrorMessage name="doctor_first_name" />
                              </small>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="form-group ">
                              <label htmlFor="" className="labels_input">
                                Last Name
                              </label>
                              <Field autoComplete="doctor_last_name"
                                className="form-control"
                                type="text"
                                id="business_last_name"
                                name="doctor_last_name"
                                placeholder="Enter last name"
                              />
                              <small className="text-danger m-2">
                                <ErrorMessage name="doctor_last_name" />
                              </small>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label htmlFor="" className="labels_input">
                                Business E-mail
                              </label>
                              <Field autoComplete="doctor_email"
                                className="form-control"
                                type="email"
                                id="business_email"
                                name="doctor_email"
                                placeholder="Enter Business email address"
                              />
                              <small className="text-danger m-2">
                                <ErrorMessage name="doctor_email" />
                              </small>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            {phoneRegex && <div className="form-group">
                              <label htmlFor="" className="labels_input">
                                Business Phone
                              </label>
                              <div className="mobilecode">
                                <p>{mobileCode}</p>
                                <div className="hide_show">
                                  <Field autoComplete="off"
                                    name="doctor_mobile"
                                    className="form-control"
                                    id="doctor_mobile"
                                  >
                                   {
                                (props: any) => <InputMask
                                  type="text"
                                  mask={phoneRegex.phoneRegexLength}
                                  maskChar={null}
                                  onChange={(event) => onPhoneChange(event, setFieldValue, true)}
                                  className="text-input form-control"
                                  id="doctor_mobile"
                                  minLength={+phoneRegex.min_phone_length}
                                  maxLength={+phoneRegex.phone_length}
                                />
                              }
                                    {/* className="form-control"
                              type="tel"
                              placeholder="Enter business phone number"
                              maxLength={10} */}
                                  </Field>
                                </div>
                              </div>
                              <small className="text-danger m-2">
                                <ErrorMessage name="doctor_mobile" />
                              </small>
                            </div>}
                          </div>
                          <div className="col-lg-6">
                            <div className="form-group arrowSelect">
                              <label htmlFor="" className="labels_input">
                                Select Industry
                              </label>
                              <Field
                                className="form-control"
                                as="select"
                                name="ind_id"
                                id="ind_id"
                                onChange={(event: any) => {
                                  industryChange(event.target.value);
                                  setFieldValue("ind_id", event.target.value)
                                }}
                              >
                                <option disabled key={0} value={""}>
                                  {"Select industry"}
                                </option>
                                {allIndustries.map((e: any, i: any) => (
                                  <option key={i} value={e.ind_id}>
                                    {e.ind_name}
                                  </option>
                                ))}
                              </Field>
                              <small className="text-danger m-2">
                                <ErrorMessage name="ind_id" />
                              </small>
                            </div>
                          </div>
                          {subIndustries?.length > 0 && (
                            <div className="col-lg-6">
                              <div className="form-group arrowSelect">
                                <label htmlFor="" className="labels_input">
                                  Select sub industry
                                </label>
                                <Field
                                  className="form-control"
                                  as="select"
                                  id="sub_ind_id"
                                  name="sub_ind_id"
                                  onChange={(event: any) => {
                                    subIndustryChange(event.target.value);
                                  }}
                                  value={selectFieldIds.sub_industry_id}
                                >
                                  {subIndustries?.map((e: any, i: any) => (
                                    <option key={i} value={e.doctor_speciality}>
                                      {e.speciality_name}
                                    </option>
                                  ))}
                                </Field>
                                <small className="text-danger m-2">
                                  <ErrorMessage name="sub_ind_id" />
                                </small>
                              </div>
                            </div>
                          )}
                          {subIndustries?.length > 0 &&
                            selectFieldIds.sub_industry_id == "9999" && (
                              <div className="col-lg-6">
                                <div className="form-group">
                                  <label htmlFor="" className="labels_input">
                                    Enter sub industry
                                  </label>
                                  <div className="sub-indus-others">
                                    <div className="hide_show">
                                      <Field autoComplete="off"
                                        className="form-control"
                                        type="text"
                                        name="sub_industry"
                                        id="sub_industry"
                                      />
                                    </div>
                                  </div>
                                  <small className="text-danger m-2">
                                    <ErrorMessage name="sub_industry" />
                                  </small>
                                </div>
                              </div>
                            )}
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label htmlFor="" className="labels_input">
                                Business Address
                              </label>
                              <div className="address">
                                <div className="hide_show">
                                  <Field autoComplete="practice_address"
                                    className="form-control"
                                    type="text"
                                    name="practice_address"
                                    placeholder="Enter business address"
                                    id="practice_address"
                                  />
                                </div>
                              </div>
                              <small className="text-danger m-2">
                                <ErrorMessage name="practice_address" />
                              </small>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label htmlFor="" className="labels_input">
                                Zip Code
                              </label>
                              <div className="address">
                                <div className="hide_show">
                                  {country_code && (
                                    <div style={{ 'border': 'solid 1px #dee2e6', 'borderRadius': '0.375rem', 'minHeight': '42px' }}>
                                      {!hidezipCode && <Autocomplete
                                        apiKey={getStorageValue("map_api_key")}
                                        className="form-control"
                                        placeholder="Enter zip code"
                                        id="autocomplete-zip"
                                        // defaultValue="Amsterdam"
                                        style={{
                                          width: "100%",
                                          height: "40px",
                                          paddingLeft: "16px",
                                        }}
                                        onPlaceSelected={(place) => {
                                          placeSelectedZip(place, setFieldValue);
                                          // setFieldValue("zip", data.zip);
                                        }}
                                        options={{
                                          fields: [
                                            "address_components",
                                            "adr_address",
                                            "geometry",
                                            "name",
                                            "formatted_address",
                                          ],
                                          types: ["(regions)"],
                                          componentRestrictions: { country: country_code },
                                        }}
                                        defaultValue={data.zip}
                                      />}
                                    </div>
                                  )}
                                </div>
                                <ErrorMessage name="zip" component="small" className="text-danger m-2" />
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label htmlFor="" className="labels_input">
                                State
                              </label>
                              <div className="address">
                                <div className="hide_show">
                                  <Field autoComplete="off"
                                    disabled
                                    className="form-control"
                                    type="text"
                                    name="state"
                                    value={data.state_name}
                                    id="state"
                                  />
                                </div>
                              </div>
                              <small className="text-danger m-2">
                                <ErrorMessage name="state" />
                              </small>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="form-group">
                              <label htmlFor="" className="labels_input">
                                City
                              </label>
                              <div className="address">
                                <div className="hide_show">
                                  <Field
                                    disabled
                                    className="form-control"
                                    type="text"
                                    name="city"
                                    value={data.city_name}
                                    id="city"
                                  />
                                </div>
                              </div>
                              <small className="text-danger m-2">
                                <ErrorMessage name="city" />
                              </small>
                            </div>
                          </div>
                          {/* <div className="col-lg-6">
                      <div className="form-group mb-3 arrowSelect">
                        <label htmlFor="" className="labels_input">
                          Preferred communication language
                        </label>
                        <Field
                          className="form-control"
                          as="select"
                          name="language_preferred"
                          onChange={(event: any) => {
                            setSelectFieldIds((data: any) => ({
                              ...data,
                              language_preferred: event.target.value
                            }))
                            setFieldValue("language_preferred", event.target.value)
                          }}
                          value={selectFieldIds.language_preferred}
                        >
                          <option disabled key={0} value={""}>
                            {"Select language"}
                          </option>
                          {language && language.map((e: any, i: any) => (
                            <option key={i} value={e.lan_code}>
                              {e.lan_name}
                            </option>
                          ))}
                        </Field>
                        <small className="text-danger m-2">
                          <ErrorMessage name="language_preferred" />
                        </small>
                      </div>
                    </div> */}
                          {(tabType == navType.NEWBUSINESS && (emailError && emailError.error && emailError.link)) && <p className="links"> <Link target="_blank" to={emailError.link}>
                            <span>Click Here </span>
                          </Link> to register your business with Credee.</p>}
                          <div className="col-12 button_chase mt-3">
                            <button disabled={sppiner || (emailError && emailError.link ? true : false)} className={`loginBtn ${emailError.link ? 'disable' : ''}`} type="submit">
                              Add business &nbsp;
                              {sppiner && (
                                <Spinner
                                  as="span"
                                  animation="border"
                                  size="sm"
                                  role="status"
                                  aria-hidden="true"
                                />
                              )}
                            </button>
                          </div>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            )}
            {tabType == navType.DIRECTINVITE && (
              <div className="Add_business d-flex">

                <div className="row">
                  <div className="col-md-6 px-md-4">
                    <div className="direct_invite">
                      <div className="form-group d-flex justify-content-center flex-column">
                        <Formik
                          onSubmit={handleInviteSubmit}
                          initialValues={directInvite}
                          validationSchema={directInviteValidation}
                        >
                          {({ setFieldValue }) => (
                            <Form>
                              <div className="row">
                                <div className="col-lg-12">
                                  <div className="form-group">
                                    <label htmlFor="" className="labels_input">
                                      Business Name
                                    </label>
                                    <Field
                                      className="form-control invite"
                                      id="business_first_name"
                                      type="text"
                                      name="doctor_first_name"
                                      placeholder="Enter business name"
                                      autoComplete="doctor_first_name"
                                    />
                                    <small className="text-danger m-2">
                                      <ErrorMessage name="doctor_first_name" />
                                    </small>
                                  </div>
                                </div>
                                <div className="col-lg-12">
                                  <div className="form-group">
                                    <label htmlFor="" className="labels_input">
                                      Business E-mail
                                    </label>
                                    <Field autoComplete="doctor_email"
                                      className="form-control invite"
                                      type="email"
                                      id="business_email"
                                      name="doctor_email"
                                      placeholder="Enter Business email"
                                    />
                                    <small className="text-danger m-2">
                                      <ErrorMessage name="doctor_email" />
                                    </small>
                                  </div>
                                </div>
                                <div className="col-lg-12">
                                  {phoneRegex && <div className="form-group">
                                    <label htmlFor="" className="labels_input">
                                      Business Phone
                                    </label>
                                    <div className="mobilecode">
                                      <p>{mobileCode}</p>
                                      <div className="hide_show">
                                        <Field autoComplete="off"
                                          name="doctor_mobile"
                                          className="form-control invite"
                                          id="doctor_mobile"
                                        >
                                          {
                                            (props: any) => <InputMask
                                              type="text"
                                              mask={phoneRegex.phoneRegexLength}
                                              maskChar={null}
                                              onChange={(event) => onPhoneChange(event, setFieldValue, false)}
                                              className="text-input form-control invite"
                                              id="doctor_mobile"
                                              minLength={+phoneRegex.min_phone_length}
                                  maxLength={+phoneRegex.phone_length}
                                            />
                                          }
                                        </Field>
                                      </div>
                                    </div>
                                    {!data.doctor_mobile && <small className="text-danger m-2">
                                      <ErrorMessage name="doctor_mobile" />
                                    </small>}
                                  </div>}
                                </div>
                                {/* <div className="col-lg-12">
                                  <div className="form-group arrowSelect">
                                    <label htmlFor="" className="labels_input">
                                      Select Preferred Language
                                    </label>
                                    <Field
                                      className="form-control invite"
                                      as="select"
                                      name="language_preffered"
                                      id="language_preffered"
                                      onChange={(event: any) => {
                                        setDirectInvite((data: any) => ({
                                          ...data,
                                          language_preffered: event.target.value
                                        }))
                                        setFieldValue("language_preffered", event.target.value)
                                      }}
                                      value={directInvite.language_preffered}
                                    >
                                      <option disabled key={0} value={""}>
                                        {"Select preferred language"}
                                      </option>
                                      {langList.map((e: any, i: any) => (
                                        <option key={i} value={e.value}>
                                          {e.label}
                                        </option>
                                      ))}
                                    </Field>
                                    <small className="text-danger m-2">
                                      <ErrorMessage name="language_preffered" />
                                    </small>
                                  </div>
                                </div> */}
                                <div className="col-12">
                                  <div className="form-group">
                                    <label htmlFor="" className="labels_input">Notes</label>
                                    <Field
                                      onKeyDown={handleInput}
                                      className="form-control"
                                      as="textarea"
                                      id="notes"
                                      name="notes"
                                      rows="5"
                                      cols="40"
                                    />
                                    <small className="text-danger m-2">
                                      <ErrorMessage name="notes" />
                                    </small>
                                  </div>
                                </div>
                              </div>
                              <div className="button_chase">
                                <button disabled={sppiner} className="loginBtn" type="submit">
                                  Send Invite
                                  {sppiner && (
                                    <Spinner
                                      as="span"
                                      animation="border"
                                      size="sm"
                                      role="status"
                                      aria-hidden="true"
                                      className="ms-2"
                                    />
                                  )}
                                </button>
                              </div>
                            </Form>
                          )}
                        </Formik>
                        {(tabType == navType.DIRECTINVITE && (emailError && emailError.error && emailError.link)) && <p className="link"> <Link target="_blank" to={emailError.link}>
                          <span>Click Here </span>
                        </Link> to register your business with Credee.</p>}
                      </div>

                    </div>
                  </div>
                  <div className="col-md-6 px-md-4">
                    <div className="-referal referal_invite text-center">
                      <div className="text-center">
                        <img className="me-2 mb-3 referImg" src={referral} alt="" />
                      </div>
                      <div style={{ fontSize: "14px" }}>
                        You can send referral code or url link to send invite
                      </div>
                      <div className="mt-3">
                        {partnerProfile.partner_profile &&
                          partnerProfile.partner_profile.length && (
                            <div
                              id="copied_invite"
                              className={`referral-box ${codeCopiedType == copyClassType.COPYREFERRALCODE
                                ? "copied"
                                : ""
                                }`}
                              onClick={() =>
                                copyToClipboard(
                                  partnerProfile.partner_profile[0]["referral_code"],
                                  copyClassType.COPYREFERRALCODE
                                )
                              }
                            >
                              {codeCopiedType == copyClassType.COPYREFERRALCODE
                                ? "Copied"
                                : partnerProfile.partner_profile[0]["referral_code"]}
                              <img
                                className="ml-4"
                                src={copy}
                                alt=""
                                style={{ width: "20px" }}
                              />
                            </div>
                          )}
                        {partnerProfile["referral_link"] && (
                          <div
                            id="referral_link"
                            className={`referral-box my-3 ${codeCopiedType == copyClassType.COPYREFERRALLINK
                              ? "copied"
                              : ""
                              }`}
                            onClick={() =>
                              copyToClipboard(
                                partnerProfile["referral_link"],
                                copyClassType.COPYREFERRALLINK
                              )
                            }
                          >
                            <span>
                              {codeCopiedType == copyClassType.COPYREFERRALLINK
                                ? "Copied"
                                : partnerProfile["referral_link"]}
                            </span>
                            <img
                              className="ml-4"
                              src={copy}
                              alt=""
                              style={{ width: "20px" }}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {tabType == navType.LOGS && (
              <>
                <div className="">
                  <div className="filterDropdown d-inline-block position-relative">
                    <Dropdown autoClose={true} style={{ 'padding': '0px 30px' }}>
                      <Dropdown.Toggle variant="primary"
                      >
                        {selectedChoice.label}
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        {choices.map((item, index) => (
                          <Dropdown.Item href="#"
                            key={index}
                            id="getReferrals"
                            onClick={() => (
                              getReferrals(item.value),
                              setSelectedChoice({ value: item.value, label: item.label })
                            )}
                          >
                            {item.label}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  {shimmer && (
                    <div className="no_data_v2 text-center">
                      <img src={dataLoading} alt="" />
                    </div>
                  )}
                  {!shimmer && (logData && logData.length > 0) &&
                    <div className="table-data-logs" style={{ 'padding': '7px 30px' }}>
                      <Table callFunction={() => console.log('call from new bus')}
                        deleteItem={(values: any) => handleDelete(values)} sendReminder={(values: any) => handleSendReminder(values)}
                        showDetail={(detail: any) => showDetail(detail)}
                        data={rows} columns={columns} showAction={true}></Table>
                    </div>}
                  {!shimmer && (!logData || (logData && !logData.length)) &&
                    <div className="no_data_v2 text-center">
                      <NoDataFound />
                    </div>
                  }
                </div>

              </>
            )}

             {isModalOpen && <ConfirmationModal
              onClose={() => {
                setItemToDelete({ id: '' })
                setModalOpen(false);
              }}
              onConfirm={handleConfirmDelete}
              message={`Are you sure you want to delete this invite?`}
            />}

            {isReminderModalOpen && <SendReminderModal
              onClose={() => {
                setItemToResend(null)
                setReminderModalOpen(false);
              }}
              onConfirm={() => {
                setReminderModalOpen(false);
                getReferrals();
              }}
              reminderData={itemToResend}
              mobileCode={mobileCode}
              mobileRegex={phoneRegex}
              type={'Business'}
            />}

            <ReminderModal
              isOpen={isDetailModalOpen}
              onClose={() => setDetailModalOpen(false)}
              data={detailData}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default NewBusinessComponent;
